import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

import Pagination from './Pagination.js';
import SelectGuide from './SelectGuide.js';
import DirectoryTable from './DirectoryTable.js';
import { file_path } from './environment';
import { filterItems } from './listUtils';

export default function Lawyers() {
    const [guides, setGuides] = useState([]);
    const [guide, setGuide] = useState({});
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [allItems, setAllItems] = useState([]);
    const [years, setYears] = useState([]);
    const [items, setItems] = useState([]);
    const [filters, setFilters] = useState({});
    const navigate = useNavigate();
    const { guideId } = useParams();

    useEffect(() => {
        document.title = `${guide.name} Lawyers`;
    }, [guide.name]);

    function handlePage(newPage) {
        setPage(newPage);
    }

    function handleChangePageSize(event) {
        const newPageSize = event.target.value;
        setPageSize(newPageSize);

        const lastPage = Math.ceil(items.length / newPageSize);
        if (page > lastPage) {
            setPage(lastPage);
        }
    }

    const guideSelected = useCallback((newGuide) => {
        if (!newGuide) {
            return;
        }

        setGuide(newGuide);
        navigate(`/lawyers/${newGuide.id}`);
        axios.get(file_path(`/lawyers/${newGuide.id}.json`)).then((res) => {
            setAllItems(res.data.lawyers);
            setItems(res.data.lawyers);
            setYears(res.data.years);
        });
    }, [navigate]);

    function handleFilterChange(event) {
        const filterId = event.target.id;
        const filterValue = event.target.value;
        const nextFilters = { ...filters };

        if (!filterValue) {
            delete nextFilters[filterId];
        } else {
            nextFilters[filterId] = filterValue;
        }

        setFilters(nextFilters);
        setItems(filterItems(allItems, nextFilters));
        setPage(1);
    }

    function findGuideById(guideList, guideId = 5) {
        return guideList.find((element) => element.id.toString() === guideId.toString());
    }

    useEffect(() => {
        axios.get(file_path('/guides.json')).then((res) => {
            setGuides(res.data.guides);

            const found = findGuideById(res.data.guides, guideId);
            if (found) {
                guideSelected(found);
            }
        });
    }, [guideId, guideSelected]);

    return (
        <div id="directory">
            <nav>
                <Link to="/guides" role="button">Home</Link>
                <Link to={`/firms/${guide.id}`} role="button">Firms</Link>
                <Link to={`/lawyers/${guide.id}`} role="button">Lawyers</Link>
            </nav>
            <h1>{guide.name} Lawyers</h1>
            <SelectGuide guides={guides} value={guide} guideSelected={guideSelected} />
            <div className="navigation">
                <Pagination page={page} pageSize={pageSize} items={items} onPage={handlePage} onChangePageSizeChange={handleChangePageSize} />
            </div>
            <div className="table">
                <DirectoryTable
                    items={items}
                    years={years}
                    page={page}
                    pageSize={pageSize}
                    filters={filters}
                    onFilterChange={handleFilterChange}
                    columns={[
                        { key: 'name', label: 'Name', field: 'name', filterable: true },
                        { key: 'firm', label: 'Firm', field: 'firm', filterable: true },
                        { key: 'location', label: 'Location', field: 'location', filterable: true },
                        { key: 'practice', label: 'Practice', field: 'practice', filterable: true },
                    ]}
                />
            </div>
            <div className="navigation">
                <Pagination page={page} pageSize={pageSize} items={items} onPage={handlePage} onChangePageSizeChange={handleChangePageSize} />
            </div>
        </div>
    );
}
